<template>
  <tr
    class="accounts__task-row"
    :class="{'accounts__task-row--new': isHasNotification}"
    @click="goToTaskLink(task.id)"
  >
    <td data-title="Задача">
      <span class="accounts__task-label" :style="`background-color: ${task.status.color}`"></span>
      {{ task.name}}
    </td>
    <td data-title="Тип задачи">
      {{ task.type.label }}
      <span class="accounts__task-mailed" v-if="fromEmail"></span>
    </td>
    <td data-title="Дата создания задачи">{{ date }}</td>
  </tr>
</template>

<script>
export default {
  props: {
    task: Object,
    date: String,
    isResponse: Boolean,
    fromEmail: String
  },

  computed: {
    isHasNotification() {
      let contain = false;

      contain = this.$store.state.notifications.some(notification => {
        return (
          notification.object_id == this.task.id &&
          (notification.type === CONST.notifications.status.taskCreated ||
            notification.type === CONST.notifications.status.commentCreated ||
            notification.type === CONST.notifications.status.taskCanceled ||
            notification.type === CONST.notifications.status.taskClosed ||
            notification.type === CONST.notifications.status.taskStatusChanged)
        );
      });

      return contain;
    }
  },

  methods: {
    goToTaskLink(id) {
      document.location = `/tasks/${id}`;
    }
  }
};
</script>
